// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockCubeBounds {
  fromX: number;
  fromY: number;
  fromZ: number;
  toX: number;
  toY: number;
  toZ: number;
}
